
    import {
        Component,
        Prop,
        Emit,
        Model,
    } from 'vue-property-decorator';

    import CheckBoxInputCommon from './common/CheckBoxInputCommon.vue';

    @Component
    export default class CheckBoxInput extends CheckBoxInputCommon {
        @Model('change') readonly modelValue!: boolean;

        @Prop() readonly label!: string;

        @Prop() readonly disabled!: boolean;

        @Prop({ default: true }) readonly hideOverflowText!: boolean;

        @Prop() readonly value!: boolean;

        @Prop() readonly checkBoxSize!: string;

        @Prop({ default: false }) readonly loading?: boolean;

        @Emit('change')
        updateInput({ target }: { target: HTMLInputElement }): boolean {

            return target.checked;
        }

        get isChecked(): boolean {
            return this.modelValue;
        }
    }

